import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Loading } from 'react-vant'

interface ProtectedRouteProps {
  children: React.ReactNode
}

// 检查token是否有效的函数
const isTokenValid = (token: string | null): boolean => {
  if (!token) return false
  
  try {
    // 这里可以添加更复杂的token验证逻辑
    // 比如检查token格式、过期时间等
    // 目前简单检查token是否存在且不为空
    return token.trim().length > 0
  } catch (error) {
    console.error('Token validation error:', error)
    return false
  }
}

// 检查用户是否已登录
const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token')
  return isTokenValid(token)
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(true)
  const [authenticated, setAuthenticated] = useState(false)

  useEffect(() => {
    // 检查登录状态
    const checkAuth = () => {
      const authStatus = isAuthenticated()
      setAuthenticated(authStatus)
      setIsLoading(false)
    }

    checkAuth()
  }, [])

  // 如果正在检查登录状态，显示加载状态
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-full">
        {/* <Loading type="ball" /> */}
      </div>
    )
  }

  // 如果未登录，跳转到登录页面，并保存当前路径
  if (!authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 如果已登录，渲染子组件
  return <>{children}</>
}

export default ProtectedRoute